export const enum MenuOptionsKeys {
    Articles = 'articles',
    Flows = 'flows',
    Forms = 'forms',
    Saved_posts = 'saved_posts',
    Shop = 'shop'
}

export type MenuOptions = Record<MenuOptionsKeys, boolean>